module.exports = __webpack_public_path__ + "static/media/home.55644be0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/home.svg
// module id = 581
// module chunks = 0